function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 4.22a4.37 4.37 0 00-1.37-3A4.6 4.6 0 008 1.63a4.6 4.6 0 00-6.63-.41 4.37 4.37 0 00-1.37 3C-.06 5.83 1.2 7.38 1.96 8.2c.78.85 2.17 2.19 3.3 3.24L8 14l2.74-2.56a71.88 71.88 0 003.3-3.25c.76-.81 2.02-2.36 1.96-3.97"
});

var SvgCoeurMcGestion = function SvgCoeurMcGestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "#fc5e27",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoeurMcGestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coeur-mc-gestion.b41b2439.svg";
export { ForwardRef as ReactComponent };